import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, BadgeCheck } from 'lucide-react';
import { colors } from '../lib/theme';

export default function DisclaimerPage() {
  return (
    <div className="min-h-screen text-slate-100" style={{ backgroundColor: colors.bgPrimary }}>
      <header
        className="sticky top-0 z-30 w-full backdrop-blur-sm"
        style={{
          borderBottom: `1px solid ${colors.border}`,
          backgroundColor: `${colors.bgSecondary}80`,
        }}
      >
        <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 h-16 flex items-center gap-4">
          <Link
            to="/"
            className="flex items-center gap-2 text-sm hover:opacity-80 transition-opacity"
            style={{ color: colors.textSecondary }}
          >
            <ArrowLeft className="h-4 w-4" />
            Back to screener
          </Link>
          <span className="font-semibold tracking-tight" style={{ color: colors.textPrimary }}>
            Disclaimer
          </span>
        </div>
      </header>

      <main className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 py-12 space-y-8">
        <section>
          <h1 className="text-3xl font-bold" style={{ color: colors.textPrimary }}>
            Disclaimer
          </h1>
          <p className="mt-4 leading-relaxed" style={{ color: colors.textSecondary }}>
            EthicCheck is a <strong style={{ color: colors.textPrimary }}>screening aid</strong>, not
            investment advice, legal advice, or a recommendation to buy or sell any security.
          </p>
        </section>

        <section className="space-y-3 text-sm leading-relaxed" style={{ color: colors.textSecondary }}>
          <p>
            Verdicts are based on publicly available datasets and rules described on our{' '}
            <Link to="/methodology" className="underline" style={{ color: colors.blue }}>
              methodology page
            </Link>
            . Coverage is incomplete by design while we expand sources — unknown tickers receive{' '}
            <strong style={{ color: colors.yellow }}>REVIEW</strong>, not a false pass.
          </p>
          <p>
            Shariah results use DJIM/S&amp;P-style ratio rules (33% debt, 33% cash, 49% receivables)
            plus a 5% interest-income / revenue screen, and curated haram-business evidence — not
            AAOIFI Standard No. 21, and not a haram-activity revenue split. Missing income-statement
            data is REVIEW, not a pass. Some rows may use estimated financials (marked in results).
            This is not a fatwa or a substitute for qualified Islamic finance guidance.
          </p>
          <p>
            Occupation &amp; settlements screening uses BDS-style research lists (e.g. AFSC
            Investigate, Who Profits) and the UN OHCHR A/HRC/60/19 business database — not a filter on
            companies by country or region. Inclusion on a list does not imply illegality; exclusion
            does not imply endorsement.
          </p>
          <p>
            Always verify sources, consult professionals, and make your own decisions before investing.
          </p>
        </section>

        <div className="flex items-center gap-2 text-sm" style={{ color: colors.textMuted }}>
          <BadgeCheck className="h-4 w-4" />
          <span>Best-effort research. Please verify before investing.</span>
        </div>
      </main>
    </div>
  );
}
